import { HttpClient } from '@angular/common/http';

import { Inject, Injectable } from '@angular/core';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { PaymentMethod } from './models';

@Injectable({ providedIn: 'root' })
export class GetPaymentMethodByCompanyKeyService {
    public constructor(public _http: HttpClient, @Inject(SETTINGS) public _settings: ISettings) {}

    // get payment methods by company key
    public execute(companyKey: string): Promise<PaymentMethod[]> {
        const getURL = `${this._settings.httpApiServiceNameUrlMap['paymentsApi']}/v1/payment-method?companyKey=${companyKey}`;
        return this._http.get<PaymentMethod[]>(getURL).toPromise();
    }
}
